import Vue from 'vue';
import Router from 'vue-router';
// 路由表按业务拆分到 ./modules/*（顺序 = 路由匹配优先级，改动请保持顺序）
//
// 两条维护规则：
// 1. 页面缓存由 App.vue 的 `$route.meta.keepAlive` 决定 —— keepAlive 必须写在 meta 里。
//    原先有 32 条写在路由记录上（不生效），已移除；需要缓存的页面请写进 meta，
//    并且页面里要有 activated 钩子处理回到页面时的刷新。
// 2. name 必须全局唯一（Vue Router 要求）；原先 home / settlement / address / bindCard
//    各有两条同名（按 name 跳转会命中前一条），已被遮蔽的那条已改名（homeAlias /
//    orderPay / userAddress / bindCardAlias）。
import base from './modules/base';
import mall from './modules/mall';
import activity from './modules/activity';
import cart from './modules/cart';
import order from './modules/order';
import user from './modules/user';
import orderSettlement from './modules/order-settlement';
import movie from './modules/movie';
import tour from './modules/tour';
import marketing from './modules/marketing';
import lifeService from './modules/life-service';
import birthday from './modules/birthday';
import lifePrivilege from './modules/life-privilege';
import afterSales from './modules/after-sales';

Vue.use(Router);

const route = new Router({
  mode: 'history',
  routes: [
    ...base,
    ...mall,
    ...activity,
    ...cart,
    ...order,
    ...user,
    ...orderSettlement,
    ...movie,
    ...tour,
    ...marketing,
    ...lifeService,
    ...birthday,
    ...lifePrivilege,
    ...afterSales
  ]
});

export default route;
